// =========================================================================================@@
// Last Updated Date: Apr 8, 2022
// Last Updated By: Steven Yuen
// Status Level: 1
// ===========================================================================================

import React from 'react'
import { Grid, GridCell, View } from 'oio-react'
import StoryListItem from 'src/sites/custom/mother-website/StoryListItem'
import MotherLayout from '../Layout'
import HomeCoverVideo from './CoverVideo'

const MotherHome = () => {
   return (
      <MotherLayout>
         <View width="100%" marginTop="30px[d-f]">
            <View
               position="relative"
               width="100%"
               paddingTop="180%[a] 120%[b] 70%[c-d] 55%[e-f]"
               backgroundColor="#000"
               marginBottom="50px">
               <HomeCoverVideo />
            </View>
            <View padding="0px 20px[a-c]">
               <Grid columns="1[a] 2[b] 2[c] 2[d] 3[e-f]">
                  <GridCell>
                     <StoryListItem
                        date="April 5, 2022"
                        imageUrl="/assets/custom/mother-website/images/gather-5.33.jpg"
                        name="Gather Version 5.33 Released"
                        subtitle="Gather (iOS, Mac, Web) is now available to private beta users, in addition to our long-standing Partner Program customers. If you are interested in becoming a beta user, please get in touch with us - we'd love to hear from you."
                     />
                  </GridCell>
                  <GridCell>
                     <StoryListItem
                        date="April 1, 2022"
                        imageUrl="/assets/custom/mother-website/images/bday-tile.jpg"
                        name="Mother turns 13"
                        subtitle="Happy April Fool’s Day! And Happy Birthday to Mother Company! We started this company 13 years ago and now it is a cranky teenager. They grow up so fast! Have a happy April 1st!"
                     />
                  </GridCell>
                  <GridCell>
                     <StoryListItem
                        date="Feb 8, 2022"
                        imageUrl="/assets/custom/mother-website/images/leather.jpg"
                        name="Journey Collection nearing completion"
                        subtitle="We are in the final product development stage for our Journey collection of products. This final stage is primarily focused on sourcing final materials and ramping up production capabilities."
                     />
                  </GridCell>
               </Grid>
            </View>
         </View>
      </MotherLayout>
   )
}

export default MotherHome
